import { Link } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import rightArrowIcon from "../../assets/Icons/black-right-arrow-icon.svg";
import instaIcon from "../../assets/Icons/insta-icon.png";
import comingSoonLottie from "../../assets/lottie-files/comingSoonEvent.lottie";
import EventsGrid from "./EventsGrid";
import SectionTitle from "../SectionTitle";
import ROUTES from "../../routes";
import { EXTERNAL_LINKS } from "../../constants/externalLinks";

const noEventsState = (
  <div style={{ textAlign: "center", padding: "2rem 1rem 1rem" }}>
    <DotLottieReact
      src={comingSoonLottie}
      loop
      autoplay
      style={{ width: "min(280px, 75vw)", height: "auto", margin: "0 auto" }}
    />
    <h3
      style={{
        color: "#143C5D",
        fontWeight: 800,
        marginTop: "0.75rem",
        fontSize: "clamp(1.2rem, 3vw, 1.6rem)",
      }}
    >
      Stay Tuned — Events Coming Soon!
    </h3>
    <p
      style={{
        color: "#666",
        maxWidth: "380px",
        margin: "0.5rem auto 1.5rem",
        lineHeight: 1.6,
      }}
    >
      We're planning our next exciting market events. Follow us on social media
      to be the first to know!
    </p>
    <div
      style={{
        display: "flex",
        gap: "0.75rem",
        justifyContent: "center",
        flexWrap: "wrap",
      }}
    >
      <a
        href={EXTERNAL_LINKS.instagram}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.4rem",
          background:
            "linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366)",
          color: "#fff",
          padding: "0.5rem 1.1rem",
          borderRadius: "999px",
          fontWeight: 700,
          textDecoration: "none",
          fontSize: "0.9rem",
        }}
      >
        <img
          src={instaIcon}
          alt=""
          width={18}
          height={18}
          style={{ filter: "brightness(10)" }}
        />
        Follow on Instagram
      </a>
      <Link
        to={ROUTES.SEE_EVENTS}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.4rem",
          background: "#143C5D",
          color: "#fff",
          padding: "0.5rem 1.1rem",
          borderRadius: "999px",
          fontWeight: 700,
          textDecoration: "none",
          fontSize: "0.9rem",
        }}
      >
        View Past Events
      </Link>
    </div>
  </div>
);

export default function UpcomingEvents() {
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <SectionTitle
        parts={[
          { text: "UPCOMING", color: "#143C5D" },
          { text: "EVENTS", color: "#47C3F7" },
        ]}
      />

      <EventsGrid limit={3} upcomingOnly emptyState={noEventsState} />

      <Link
        to={ROUTES.SEE_EVENTS}
        rel="noreferrer"
        style={{
          color: "black",
          padding: "1px 1px",
          textDecoration: "none",
          display: "inline-flex",
          gap: "5px",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bolder",
        }}
      >
        🔍 Explore All Events
        <img src={rightArrowIcon} alt="rightArrow" width={22} height={22} />
      </Link>
    </div>
  );
}
